const t = { mob: 480, phab: 560, tab: 768, desk: 980 },
  e = (t, e) => {
    let n = 0;
    return (...a) => {
      clearTimeout(n), (n = setTimeout(() => t(...a), e));
    };
  },
  n = (t, e) => {
    let n = t,
      a = "";
    const s = /\{\{\s*(\w+)\s*\}\}/,
      r = e;
    function i(t, e = 2, n = ",", a = ".") {
      if (Number.isNaN(t) || null === t) return 0;
      const s = (t / 100).toFixed(e).split(".");
      return (
        s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`) +
        (s[1] ? a + s[1] : "")
      );
    }
    switch (("string" == typeof n && (n = n.replace(".", "")), r.match(s)[1])) {
      case "amount":
        a = i(n, 2);
        break;
      case "amount_no_decimals":
        a = i(n, 0);
        break;
      case "amount_with_comma_separator":
        a = i(n, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        a = i(n, 0, ".", ",");
    }
    return r.replace(s, a);
  },
  a = (t) =>
    t
      .toString()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/_/g, "-")
      .replace(/--+/g, "-")
      .replace(/-$/g, ""),
  s = (t) => !(t.offsetWidth || t.offsetHeight || t.getClientRects().length),
  r = (t, e, n, a, s) => {
    const r = a / s,
      i = e / n;
    let o = 0,
      u = 0;
    return (
      (t ? r > i : r < i) ? ((o = e), (u = o / r)) : ((u = n), (o = u * r)),
      { width: o, height: u, x: (e - o) / 2, y: (n - u) / 2 }
    );
  },
  i = (t) =>
    Array.from(
      t.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    ),
  o = () => {
    document.querySelectorAll(".js-youtube").forEach((t) => {
      t.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }),
      document.querySelectorAll(".js-vimeo").forEach((t) => {
        t.contentWindow.postMessage('{"method":"pause"}', "*");
      }),
      document.querySelectorAll("video").forEach((t) => t.pause()),
      document.querySelectorAll("product-model").forEach((t) => {
        t.modelViewerUI && t.modelViewerUI.pause();
      });
  },
  u = {},
  l = (t = null) => {
    document.removeEventListener("focusin", u.focusin),
      document.removeEventListener("focusout", u.focusout),
      document.removeEventListener("keydown", u.keydown),
      t && t.focus();
  },
  c = (t, e = t) => {
    const n = i(t),
      a = n[0],
      s = n[n.length - 1];
    l(),
      (u.focusin = (e) => {
        (e.target !== t && e.target !== s && e.target !== a) ||
          document.addEventListener("keydown", u.keydown);
      }),
      (u.focusout = () => {
        document.removeEventListener("keydown", u.keydown);
      }),
      (u.keydown = (e) => {
        "TAB" === e.code.toUpperCase() &&
          (e.target !== s || e.shiftKey || (e.preventDefault(), a.focus()),
          (e.target !== t && e.target !== a) ||
            !e.shiftKey ||
            (e.preventDefault(), s.focus()));
      }),
      document.addEventListener("focusout", u.focusout),
      document.addEventListener("focusin", u.focusin),
      e.focus();
  };
class d {
  #t;
  #e;
  constructor({ interval: t, callback: e }) {
    (this.interval = t),
      (this.timeRemaining = t),
      (this.callback = e),
      (this.#t = null),
      (this.#e = null),
      (this.status = "ready");
  }
  start() {
    "running" !== this.status &&
      "stopped" !== this.status &&
      ((this.status = "running"),
      (this.#e = Date.now()),
      (this.#t = setInterval(this.callback, this.interval)));
  }
  stop() {
    if ("stopped" === this.status || "ready" === this.status || !this.#e)
      return;
    (this.status = "stopped"), clearInterval(this.#t);
    const t = Date.now() - this.#e;
    this.timeRemaining -= t;
  }
  resume() {
    "running" !== this.status &&
      "ready" !== this.status &&
      this.#e &&
      ((this.status = "running"),
      (this.#e = Date.now()),
      (this.#t = setInterval(this.callback, this.timeRemaining)));
  }
  reset() {
    (this.status = "ready"),
      (this.timeRemaining = this.interval),
      (this.#e = null),
      clearInterval(this.#t),
      (this.#t = null);
  }
}
export {
  t as BREAKPOINTS,
  d as ResumableInterval,
  e as debounce,
  n as formatMoney,
  i as getFocusableElements,
  r as getObjectFitSize,
  a as handle,
  s as isHidden,
  o as pauseAllMedia,
  l as removeTrapFocus,
  c as trapFocus,
};
